"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearFailures = exports.CLEAR_FAILURES = void 0;
exports.CLEAR_FAILURES = 'CLEAR_FAILURES';
function clearFailures() {
    return { type: exports.CLEAR_FAILURES };
}
exports.clearFailures = clearFailures;
